<template>
  <div>
    <stdDialog
      :title="'選擇' + title"
      :key="key"
      :visible.sync="modalOpen"
      :modal-append-to-body="false"
      top="10vh"
      width="100%">
      <div class="cascader-selector">
        <slot></slot>
      </div>
    </stdDialog>
  </div>
</template>

<script>
const { reactive, toRefs, watch } = Vue;
import Dialog from 'element-ui/lib/dialog';
import stdDialog from '../utilities/std-dialog';

export default {
  name: 'modal',
  components: {
    Dialog,
    stdDialog,
  },
  props: {
    open: Boolean,
    title: String,
  },
  setup(props, event) {
    const state = reactive({
      modalOpen: props.open,
      key: u.uid()
    });

    watch(() => props.open, (v) => {
      const bar = document.getElementsByClassName('c-search-bar');

      v ? bar[0].style.zIndex = 1031 : bar[0].style.zIndex = 3;

      state.modalOpen = v;
    });

    watch(() => state.modalOpen, (v) => {
      if (!v) {
        event.emit('close');
      }
    });

    return {
      ...toRefs(state),
    };
  }
};
</script>

<style scoped>

</style>
